import  { useEffect, useState } from "react";
import { RiArrowLeftLine, RiSave2Fill } from "react-icons/ri";
import { useHistory } from "react-router";
import Button from "../../../components/elements/button/Button";
import AmbraInputCheckbox from "../../../components/elements/form/AmbraInputCheckbox";
import AmbraInputText from "../../../components/elements/form/AmbraInputText";

import Subtitle from "../../../components/elements/text/Subtitle";
import Title from "../../../components/elements/text/Title";
import AuthContainer from "../../../components/layout/auth/AuthContainer";
import useAlerts from "../../../hooks/useAlerts";
import { useQuery } from "../../../hooks/useQuery";

import sectorsService from "../../../services/sectorsService";

const PRCreateCompanySector = () => {
  const history = useHistory();
  const query = useQuery();
  const alerts = useAlerts();

  const [dataSector, setDataSector] = useState<any>([]);

  const [editId, setEditId] = useState<string>("0");
  const [name, setName] = useState<string>("");
  const [active, setActive] = useState<boolean>(true);
  const [company, setCompany] = useState<string>("");
  const [updateCounter, setUpdateCounter] = useState<number>(0);
  const [field, setField] = useState<string>("");

  useEffect(() => {
    let companyId = localStorage.getItem("company");
    if (companyId) {
      setCompany(companyId);
    }
    let sectorId = query.get("id");
    if (sectorId) {
      setEditId(sectorId);
    }
    let fieldId = query.get("fieldId");
    if (fieldId) {
      setField(fieldId);
    }
  }, []);

  useEffect(() => {
    if (editId !== "0") {
      sectorsService.get(editId).then((response) => {
        if (response.status) {
          getObjectFromRequest(response.data);
        }
      });
    }
  }, [editId]);

  useEffect(() => {
    if (company !== "" && editId !== "0") {
      sectorsService.list(editId).then((response) => {
        if (response.status === 200) {
          setDataSector(response.data);
        }
      });
    }
  }, [updateCounter, company, editId]);

  const getObjectFromRequest = (area: any) => {
    setName(area.name);
    setActive(area.active);
    setCompany(area.company);
    setField(area.field);
  };

  const handleStoreError = () => {
    alerts.showAlert("error", "Ops", "Ocorreu um erro ao salvar a área.");
  };

  const store = () => {
    let requestData = {
      name: name,
      company: company,
      active: active,
      field: field,
    };
    if (editId === "0") {
      console.log(requestData);
      sectorsService
        .store(requestData)
        .then((response) => {
          if (response.status) {
            alerts.showAlert("success", "Sucesso", "Setor salvo com sucesso");
            history.push("/auth/PR");
          } else {
            handleStoreError();
          }
        })
        .catch((error) => {
          console.log(error.request)
          handleStoreError();
        });
    } else {
      sectorsService
        .put(editId, requestData)
        .then((response) => {
          if (response.status) {
            alerts.showAlert("success", "Sucesso", "Setor salvo com sucesso");
            history.push("/auth/PR");
          } else {
            handleStoreError();
          }
        })
        .catch((error) => {
          handleStoreError();
        });
    }
  };

  return (
    <AuthContainer>
      <div className="m-3 mt-4 mb-4">
        <div className="mb-4">
          <Title> Criar/Editar Setor </Title>
          <Subtitle>
            {" "}
            Parametrização {">"} Unidades {">"} Adicionar Setor{" "}
          </Subtitle>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-7 gap-5 mb-5">
          <div className="col-span-4">
            <AmbraInputText
              label="Nome do setor"
              placeholder="Ex. Manutenção de máquinas"
              validation="required"
              value={name}
              onChange={(e: any) => {
                setName(e.target.value.toUpperCase());
              }}
            />
          </div>
          <div className="col-span-3">
            <AmbraInputCheckbox
              label="Disponibilidade"
              onChange={(e) => {
                setActive(!active);
              }}
              checked={active}
              value="Ativo"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-2 gap-5 mt-5">
          <div className="col-start-6">
            <Button
              type="primary"
              className="mr-2"
              onClick={() => {
                history.push("/auth/PR/");
              }}
            >
              <RiArrowLeftLine className="inline-block text-white-700" /> Voltar
            </Button>
            <Button
              type="primary"
              onClick={() => {
                store();
              }}
              className="ml-2"
            >
              Salvar Setor{" "}
              <RiSave2Fill className="inline-block text-white-700" />
            </Button>
          </div>
        </div>
      </div>
    </AuthContainer>
  );
};

export default PRCreateCompanySector;
